import { z } from 'zod';
import { paginationQuerySchema } from '../pagination.js';
/**
 * Actions tracees.
 * P0 : socle technique (comptes, authentification).
 * P1 : referentiels et imports.
 * Les actions du cycle anomalies/solde seront ajoutees en P3.
 */
export const AUDIT_ACTIONS = [
    'LOGIN_SUCCESS',
    'LOGIN_FAILURE',
    'LOGIN_BLOCKED',
    'LOGOUT',
    'PASSWORD_CHANGED',
    'USER_CREATED',
    'USER_UPDATED',
    'USER_DELETED',
    'PRODUCT_UPDATED',
    'MOVEMENT_TYPE_CREATED',
    'MOVEMENT_TYPE_UPDATED',
    'FAMILY_CREATED',
    'FAMILY_UPDATED',
    'FAMILY_VALIDATED',
    'FAMILY_REJECTED',
    'FAMILY_DELETED',
    'FAMILY_DETECTION_RUN',
    'FAMILY_AUTO_VALIDATED',
    'FAMILY_DEACTIVATED',
    'FAMILY_EXTENSION_AUTO_APPLIED',
    'FAMILY_EXTENSION_VALIDATED',
    'FAMILY_EXTENSION_REJECTED',
    'IMPORT_STARTED',
    'IMPORT_COMPLETED',
    'IMPORT_FAILED',
    'IMPORT_BACKFILL_CONFIRMED',
    'IMPORT_ANCHOR_CONFIRMED',
    'DISCREPANCY_VALIDATED',
    'DISCREPANCY_VALIDATED_FINAL',
    'DISCREPANCY_VALIDATION_CANCELLED',
    'DISCREPANCY_COMMENTED',
    'DISCREPANCY_RECALCULATED',
    'DATA_RESET',
    'RECONCILIATION_CREATED',
    'RECONCILIATION_CANCELLED',
    'RECONCILIATION_CONFLICT_ACKNOWLEDGED',
    'RECONCILIATION_TYPE_CREATED',
    'RECONCILIATION_TYPE_UPDATED',
    'COMMENT_TYPE_CREATED',
    'COMMENT_TYPE_UPDATED',
];
export const AUDIT_ACTION_LABELS = {
    LOGIN_SUCCESS: 'Connexion réussie',
    LOGIN_FAILURE: 'Échec de connexion',
    LOGIN_BLOCKED: 'Connexion temporisée',
    LOGOUT: 'Déconnexion',
    PASSWORD_CHANGED: 'Mot de passe modifié',
    USER_CREATED: 'Utilisateur créé',
    USER_UPDATED: 'Utilisateur modifié',
    USER_DELETED: 'Utilisateur supprimé',
    PRODUCT_UPDATED: 'Article modifié',
    MOVEMENT_TYPE_CREATED: 'Type de mouvement créé',
    MOVEMENT_TYPE_UPDATED: 'Type de mouvement modifié',
    FAMILY_CREATED: "Famille d'équivalence créée",
    FAMILY_UPDATED: "Famille d'équivalence modifiée",
    FAMILY_VALIDATED: "Famille d'équivalence validée",
    FAMILY_REJECTED: "Famille d'équivalence rejetée",
    FAMILY_DELETED: "Famille d'équivalence supprimée",
    FAMILY_DETECTION_RUN: 'Détection des familles lancée',
    FAMILY_AUTO_VALIDATED: "Famille d'équivalence validée automatiquement",
    FAMILY_DEACTIVATED: "Famille d'équivalence désactivée",
    FAMILY_EXTENSION_AUTO_APPLIED: "Extension d'une famille appliquée automatiquement",
    FAMILY_EXTENSION_VALIDATED: "Extension d'une famille validée",
    FAMILY_EXTENSION_REJECTED: "Extension d'une famille rejetée",
    IMPORT_STARTED: 'Import démarre',
    IMPORT_COMPLETED: 'Import terminé',
    IMPORT_BACKFILL_CONFIRMED: 'Rattrapage confirmé',
    IMPORT_ANCHOR_CONFIRMED: "Ré-ancrage d'inventaire confirmé",
    DISCREPANCY_VALIDATED: 'Écart validé temporairement',
    DISCREPANCY_VALIDATED_FINAL: 'Écart validé définitivement',
    DISCREPANCY_VALIDATION_CANCELLED: 'Validation d’écart annulée',
    IMPORT_FAILED: 'Import en échec',
    DISCREPANCY_COMMENTED: 'Commentaire ajouté à un écart',
    DISCREPANCY_RECALCULATED: 'Écarts recalculés à la demande',
    DATA_RESET: 'Remise à zéro des données importées',
    RECONCILIATION_CREATED: 'Rapprochement manuel enregistré',
    RECONCILIATION_CANCELLED: 'Rapprochement manuel annulé',
    RECONCILIATION_CONFLICT_ACKNOWLEDGED: 'Conflit de rapprochement acquitté',
    RECONCILIATION_TYPE_CREATED: 'Type de rapprochement créé',
    RECONCILIATION_TYPE_UPDATED: 'Type de rapprochement modifié',
    COMMENT_TYPE_CREATED: 'Type de commentaire créé',
    COMMENT_TYPE_UPDATED: 'Type de commentaire modifié',
};
export const AUDIT_ENTITIES = [
    'AUTH',
    'USER',
    'APP_SETTING',
    'PRODUCT',
    'MOVEMENT_TYPE',
    'COMMENT_TYPE',
    'RECONCILIATION_TYPE',
    'RECONCILIATION',
    'ARTICLE_FAMILY',
    'IMPORT_BATCH',
    'DISCREPANCY',
    /** La base elle-meme : remise a zero des donnees importees (A26). */
    'DATABASE',
];
export const auditQuerySchema = paginationQuerySchema.extend({
    action: z.string().trim().max(60).optional(),
    entity: z.string().trim().max(60).optional(),
    userId: z.string().uuid().optional(),
    from: z.string().datetime({ offset: true }).optional(),
    to: z.string().datetime({ offset: true }).optional(),
});
//# sourceMappingURL=audit.js.map